   <!-- GlobalSnackbar.vue -->
   <template>
     <v-snackbar
       v-model="snackbar.visible"
       :timeout="snackbar.timeout"
       :color="snackbar.color"
       :top="isTop"
       :bottom="isBottom"
       :left="isLeft"
       :right="isRight"
     >
       {{ snackbar.message }}
       <v-btn color="white" text @click="snackbar.visible = false">Close</v-btn>
     </v-snackbar>
   </template>

  <script>
  export default {
    data() {
      return {
        snackbar: {
          visible: false,
          message: '',
          timeout: 3000,
          color: 'info',
          position: 'center'
        }
      };
    },
    computed: {
      isTop() {
        return ['top-left', 'top-center', 'top-right'].includes(this.snackbar.position);
      },
      isBottom() {
        return ['bottom-left', 'bottom-center', 'bottom-right'].includes(this.snackbar.position);
      },
      isLeft() {
        return ['top-left', 'left-center', 'bottom-left'].includes(this.snackbar.position);
      },
      isRight() {
        return ['top-right', 'right-center', 'bottom-right'].includes(this.snackbar.position);
      }
    },
    methods: {
      showMessage(message, status = 'info', timeout = 3000, position = 'center') {
        this.snackbar.message = message;
        this.snackbar.timeout = timeout;
        this.snackbar.color = this.getColorByStatus(status);
        this.snackbar.position = position;
        this.snackbar.visible = true;
      },
      getColorByStatus(status) {
        switch (status) {
          case 'success':
            return 'green';
          case 'error':
            return 'red';
          case 'warning':
            return 'orange';
          case 'info':
          default:
            return 'blue';
        }
      }
    },
    mounted() {
      this.$eventBus.on('show-snackbar', this.showMessage);
    },
    beforeUnmount() {
      this.$eventBus.off('show-snackbar', this.showMessage);
    }
  };
  </script>